import * as React from 'react';
export class Interactions extends React.Component {
    render() {
        return (React.createElement("div", null, this.props.children));
    }
}